import { Link } from 'react-router-dom';

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm text-foreground-500 flex-wrap">
      {items.map((item, i) => (
        <span key={`${item.label}-${i}`} className="flex items-center gap-1.5">
          {i > 0 && <i className="ri-arrow-right-s-line text-foreground-300" />}
          {item.to ? (
            <Link to={item.to} className="hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-900 font-medium whitespace-nowrap">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}